import {
    PDP_PAGE_LOAD_READY_SUCCESS,
    PDP_PAGE_LOAD_READY_ONRESET,
} from '../actionTypes/AnalyticsActionTypes';

function AnalyticsReducer(state = {}, action) {
    switch (action.type) {
        case PDP_PAGE_LOAD_READY_SUCCESS:
            return action.payload;
        case PDP_PAGE_LOAD_READY_ONRESET:
            return action.payload;
        default:
            return state;
    }
}

export default AnalyticsReducer;
